import { IRootScopeService, IScope } from "angular";
import { IBadgeAssignment, IBadge } from "./models/badges";

interface IBroadcastBadgeChangesArgs {
  badge: IBadge;
}

export interface IBadgeAwardChangedArgs extends IBroadcastBadgeChangesArgs {
  assignment: IBadgeAssignment;
  action: "assigned" | "unassigned";
}

export class BadgeEvents {
  private $rootScope: IRootScopeService;
  constructor(private $scope: IScope) {
    this.$rootScope = this.$scope.$root;
  }

  public broadcastBadgeAwardChanged(options: IBadgeAwardChangedArgs): void {
    this.$rootScope.$broadcast("badgeAwardChanged", options);
  }

  onBadgeAwardChanged(callback: (args: IBadgeAwardChangedArgs) => unknown): void {
    this.$scope.$on("badgeAwardChanged", (evt, args: IBadgeAwardChangedArgs) => callback(args));
  }
}
